/**
 * @description Add "https://" to a url if the url does not already contain "https://".
 *
 * @example withHttps('www.example.com')
 */
const withHttps = (url: string) =>
  !/^(https?:)?\/\//i.test(url) ? `https://${url}` : url;

export default withHttps;
